// معرفی انبارها + مسئول انبار
import React, { useState } from 'react';
import { ui } from '../../components/ListPage';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import CrudView from './CrudView';
import { Field, TextInput, Lookup } from './basicShared';

const COLS = [
  { key: 'code', label: 'کد' }, { key: 'title', label: 'عنوان' },
  { key: 'address', label: 'آدرس' }, { key: 'keeper', label: 'انباردار' },
];
const PEOPLE_COLS = [{ key: 'date', label: 'تاریخ' }, { key: 'person', label: 'مسئول' }];

function Fields({ f, set }) {
  return (
    <>
      <div style={ui.row}>
        <Field label="کد" width="120px"><TextInput value={f.code} onChange={v => set('code', v)} ltr autoFocus /></Field>
        <Field label="عنوان"><TextInput value={f.title} onChange={v => set('title', v)} /></Field>
      </div>
      <div style={ui.row}>
        <Field label="آدرس"><TextInput value={f.address} onChange={v => set('address', v)} /></Field>
      </div>
    </>
  );
}

function PeopleFields({ f, set, setMany }) {
  return (
    <div style={ui.row}>
      <Lookup label="مسئول" text={f.person} endpoint="/stock-people/lookup/person/"
        onPick={r => setMany({ people_id: r.id, person: r.title || '' })} />
      <Field label="تاریخ" width="160px"><JalaliDatePicker value={f.date} onChange={v => set('date', v)} /></Field>
    </div>
  );
}

/** مسئول انبار — props: stock {id, title}, onClose */
export function StockPeople({ stock, onClose }) {
  return (
    <CrudView asDialog onClose={onClose} form="FRMSTOCKPEOPLE" title={`مسئول انبار — ${stock.title}`}
      path={`/stocks/${stock.id}/people`} cols={PEOPLE_COLS} unit="ردیف"
      empty={{ people_id: 0, person: '', date: '' }} renderFields={PeopleFields} />
  );
}

export default function Stock({ user, onBack }) {
  const [people, setPeople] = useState(null);
  return (
    <CrudView user={user} onBack={onBack} form="FRMSTOCK" title="انبارها" unit="انبار" buttons={['BTNSTOCKPEOPLE']}
      path="/stocks" cols={COLS} empty={{ code: '0', title: '', address: '' }} renderFields={Fields}
      reloadKey={people ? 1 : 0}
      extraModalButtons={({ edit, sel, fb }) => (edit.mode === 'edit' && sel && fb.can('BTNSTOCKPEOPLE')
        ? <button onClick={() => setPeople({ id: sel.id, title: sel.title })} style={ui.btnItems}>مسئول انبار</button> : null)}>
      {() => people && <StockPeople stock={people} onClose={() => setPeople(null)} />}
    </CrudView>
  );
}
